
import { useLoadingStore } from '@/modules/shared/stores/loadingStore'
import { axiosInstance } from '@/modules/shared/lib/axios'
import axios from 'axios'
import { DriverAddForm } from '../types/driver'
import { useInvalidateDriverRequiredActions } from '@/lib/api/company/drivers/useQueryDriverRequiredActions'

const useDriverService = () => {
  const startLoading = useLoadingStore((s) => s.startLoading)
  // Data urodzenia / PESEL i umowa zmieniają znacznik ulgi dla młodych w panelu kierowców.
  const invalidateDriverRequiredActions = useInvalidateDriverRequiredActions()
  const addDriver = async ({
    companyId,
    driver,
  }: {
    companyId: string
    driver: DriverAddForm
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(`/api/${companyId}/driver/save`, {
        driver: driver,
      })
      invalidateDriverRequiredActions()
      return res
    } catch (err) {
      throw err
    } finally {
      stopLoading()
    }
  }
  const testEndpoint = async ({ companyId }) => {
    const stopLoading = startLoading()
    try {
      ;('')
      const res = await axios.get(
        `/api/${companyId}/drivers/extended`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const activateDriver = async ({
    companyId,
    driversIds,
    setActive,
  }: {
    companyId: string
    driversIds: number[]
    setActive: boolean
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/driver/activate`,
        {
          companyId: companyId,
          drivers: driversIds,
          activate: setActive,
        },
      )
      return res.data
    } catch (err) {
      throw err
    } finally {
      stopLoading()
    }
  }
  const getDriverContracts = async ({ companyId, driverId }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(
        `/api/${companyId}/contract?driverId=${driverId}`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const addContract = async ({ companyId, driverId, contract }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(`/api/${companyId}/contract/save`, {
        ...contract,
        // companyId: companyId,
        // driverId :driverId,
      })
      invalidateDriverRequiredActions()
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const getDriversPoor = async ({ companyId }) => {
    try {
      const res = await axiosInstance.get(
        `/api/${companyId}/drivers/basic`,
      )
      return res.data
    } catch (err) {
      return []
    }
  }
  const getDrivers = async ({ companyId, onlyActive, loading = true }) => {
    const stopLoading = loading ? startLoading() : null
    try {
      const res = await axiosInstance.get(
        `/api/${companyId}/drivers${onlyActive ? '?isActive=true' : ''}`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading?.()
    }
  }
  const getDriver = async ({ companyId, driverId, withPersonalData }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(
        `api/${companyId}/driver/${driverId}?withPersonalData=${withPersonalData}`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  // Pierwsza umowa kierowcy, a gdy jej brak - data rozpoczęcia pracy z kartoteki.
  const getDriverWorkStartDate = async ({
    companyId,
    driverId,
  }): Promise<string | null> => {
    try {
      const res = await axiosInstance.get(
        `api/${companyId}/driver/workStartDate?driverId=${driverId}`,
      )
      const date: string | undefined = res.data?.workStartDate?.split('T')[0]
      return date && !date.startsWith('0001') ? date : null
    } catch (err) {
      return null
    }
  }
  // TODO - MOVE THAT FUNCTION
  const getDriverGroups = async ({ companyId }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(`/api/${companyId}/driver/groups`)
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const getDriversInGroup = async ({ companyId, groupId }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(
        `api/${companyId}/driver/driversInGroup?&groupId=${groupId}`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }

  return {
    addDriver,
    getDrivers,
    getDriver,
    getDriverWorkStartDate,
    getDriverGroups,
    getDriversInGroup,
    activateDriver,
    getDriverContracts,
    testEndpoint,

    addContract,
    getDriversPoor
  }
}

export default useDriverService
